import { IPaginatedParams, PageInfo } from '../../share-types'

export enum SalesCampaignStatusEnums {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  INTERNAL_ONLY = 'INTERNAL_ONLY',
}

export interface ISalesCampaignFilterParams {
  name?: string
  status?: SalesCampaignStatusEnums
}

export type PaginatedSalesCampaignFilterParams = IPaginatedParams & ISalesCampaignFilterParams

export type ISalesCampaign = {
  id: number
  name: string
  planId?: number
  couponTemplateId?: number
  floatingPortalUrl?: string
  chargeBannerUrl?: string
  enableCouponReminder: boolean
  status: SalesCampaignStatusEnums
  startDatetime: string
  endDatetime: string
  planName?: string
  couponTemplateName?: string
  createdAt: string
  updatedAt: string
}

export type PaginatedSalesCampaign = {
  pageInfo: PageInfo
  data: ISalesCampaign[]
}

export interface ISalesCampaignFormData {
  name: string
  planId?: number
  couponTemplateId?: number
  floatingPortalUrl?: any
  chargeBannerUrl?: any
  enableCouponReminder: boolean
  status: SalesCampaignStatusEnums
  startDatetime: string
  endDatetime: string
}
